export default "{\n    \"emptyPlaceholder\": \"Cliquez pour sélectionner un établissement\",\n    \"searchPlaceholder\": \"Rechercher par nom ou adresse\"\n}\n"